module.exports = __webpack_public_path__ + "static/media/goalwise.56b09391.svg";